function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconHomeFillSm = function SvgIconHomeFillSm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    stroke: props.color,
    d: "M2.25 13.286h3.047V21h13.406v-7.714h3.047L12 3 2.25 13.286z",
    clipRule: "evenodd"
  }));
};
export default SvgIconHomeFillSm;